import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 -SiteInfoView 개발
 *
 ********************************************************************/
import { useRecoilValue } from "recoil";
import { adminTypeState, curAdminTreeState } from "../../../../../recoil/assessmentState";
import SiteRoom from "./SiteRoom";
import SiteSubZone from "./SiteSubZone";
import SiteZone from "./SiteZone";
function SitemViewMain(props) {
    //recoil
    const recoilTree = useRecoilValue(curAdminTreeState);
    const recoilType = useRecoilValue(adminTypeState);
    // props
    const { handleOpenPop, onClickTab, isMobile } = props;
    return (_jsxs(_Fragment, { children: [recoilTree.zone.zoneId && recoilType == "zone" && (_jsx(SiteZone, { handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile })), recoilTree.subZone.subZoneId && recoilType == "subZone" && (_jsx(SiteSubZone, { handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile })), recoilTree.room.roomId && recoilType == "room" && (_jsx(SiteRoom, { handleOpenPop: handleOpenPop, onClickTab: onClickTab, isMobile: isMobile }))] }));
}
export default SitemViewMain;
